<form #phonesForm="ngForm">
  <div class="toolbar">
    <span>
      <button matButton="text" (click)="backToOrganizationDetail()">
        <span>
          <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
          <label>Back To Organization</label>
        </span>
      </button>
    </span>
    <span class="spacer"></span>
    <span>
      @if (!isNew() && selectedPhone()) {
        <button matButton="text" (click)="deletePhone()">
          <span>
            <mat-icon class="size-16">remove</mat-icon>
            <label>Delete</label>
          </span>
        </button>
      }
      @if (!isNew()) {
        <button matButton="text" (click)="newPhone()">
          <span>
            <mat-icon class="size-16">add</mat-icon>
            <label>New</label>
          </span>
        </button>
      }
      <button matButton="text" [disabled]="!selectedPhone() || phonesForm.invalid" (click)="save()">
        <span>
          <mat-icon class="size-16">done</mat-icon>
          <label>Save</label>
        </span>
      </button>
    </span>
  </div>
  <div class="phonesWrapper">
    <div class="leftColumn">
      <table class="reportTable">
        <thead>
          <tr>
            <td class="tableCell headerCell">Type</td>
            <td class="tableCell headerCell">Number</td>
          </tr>
        </thead>
        @if (phones() && phones().length > 0) {
          @for (phone of phones(); track phone; let rowIndex = $index) {
            <tr [class.selectedRow]="rowIndex === selectedRowId()" class="selectableRow"
              (click)="selectPhone(rowIndex, phone)">
              <td class="tableCell">{{ phone.relationshipTypeDescription }}</td>
              <td class="tableCell">{{ phone.phoneNumber }}</td>
            </tr>
          }
        }
        @if (!phones() || phones().length === 0) {
          <tr>
            <td class="tableCell centeredCell" colspan="2">No phones found</td>
          </tr>
        }
      </table>
    </div>
    <div class="rightColumn">
      @if (selectedPhone(); as selectedPhone) {
        <table>
          <tr>
            <td class="labelColumn">
              <label for="phoneTypeSelection">Phone Type:</label>
            </td>
            <td class="inputColumn">
              <select name="phoneTypeSelection" id="phoneTypeSelection" class="inputField"
                [(ngModel)]="selectedPhone.relationshipTypeCode">
                @for (phoneType of phoneTypes(); track phoneType) {
                  <option [value]="phoneType.code">{{ phoneType.description }}
                  </option>
                }
              </select>
            </td>
          </tr>
          <tr>
            <td class="labelColumn">
              <label for="phoneNumberInput">Phone Number:</label>
            </td>
            <td class="inputColumn">
              <input id="phoneNumberInput" name="phoneNumberInput" maxlength="20" class="inputField standardTextBox"
                [ngClass]="{'inputError': phoneNumberInput.invalid}" required
                [(ngModel)]="selectedPhone.phoneNumber"
                #phoneNumberInput="ngModel"/>
            </td>
          </tr>
        </table>
      }
    </div>
  </div>
</form>
